import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'descripcion',
    label: i18n('entities.tipoServicio.fields.descripcion'),
    schema: schemas.string(
      i18n('entities.tipoServicio.fields.descripcion'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoServicio.fields.habilitado'),
    schema: schemas.boolean(
      i18n('entities.tipoServicio.fields.habilitado'),
      {},
    ),
  },
];